import { defaultNaviParams } from "@/helpers/defaultValue";
import { useNaviPaper } from "@/hooks/useNavi";
import useTranslation from "@/hooks/useTranslation";
import { NaviParams } from "@/interfaces/navi.interface";
import { sideBarState } from "@/stores/common";
import { naviMergedField } from "@/stores/navi";
import { Button, ButtonGroup } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import DateFilter from "./Date";
import Factor from "./Factor";
import Sort from "./Sort";
import styles from "./styles.module.less";
import Type from "./Type";

const { wrapper } = styles;

const Filter: React.FC = () => {
  const [_searchParams, _setSearchParams] = useRecoilState<Partial<NaviParams>>(
    naviMergedField("searchParams")
  );

  const { handleFilter, loadingSearch } = useNaviPaper();
  const setSideBar = useSetRecoilState(sideBarState);
  const { t } = useTranslation("explore");

  const [searchParams, __setSearchParams] = useState<Partial<NaviParams>>({});

  useEffect(() => {
    __setSearchParams(_searchParams);
  }, [_searchParams]);

  const setSearchParams = (value: Partial<NaviParams>) => {
    __setSearchParams({ ...searchParams, ...value });
  };

  return (
    <div className={wrapper}>
      <ButtonGroup>
        <Button
          variant="outlined"
          color="primary"
          disabled={loadingSearch}
          onClick={async () => {
            _setSearchParams(searchParams);
            await handleFilter(searchParams);
            setSideBar({ sideBar: false });
          }}
        >
          {t("pubmed.sidebar.apply")}
        </Button>
        <Button
          color="default"
          variant="outlined"
          onClick={() => {
            _setSearchParams(defaultNaviParams);
            __setSearchParams(defaultNaviParams);
          }}
        >
          {t("pubmed.sidebar.reset")}
        </Button>
      </ButtonGroup>
      <Sort sort={searchParams.sort} setSearchParams={setSearchParams} />
      <DateFilter
        mindate={searchParams.mindate}
        maxdate={searchParams.maxdate}
        setSearchParams={setSearchParams}
      />
      <Factor
        ifFilter={searchParams.ifFilter}
        ifFilterMax={searchParams.ifFilterMax}
        ifFilterMin={searchParams.ifFilterMin}
        setSearchParams={setSearchParams}
      />
      <Type
        articleTypeFilterList={searchParams.articleTypeFilterList}
        setSearchParams={setSearchParams}
      />
    </div>
  );
};
export default Filter;
